$(document).ready(function(){

    $('#areaSelect').change(function(){
        var path = $('#areaSelect option:selected').val();
        if(path){
            window.location.href = path
        }
    })
});